import { Component, Input } from '@angular/core';

@Component({
  selector: 'ds-vertical-divider',
  templateUrl: './vertical-divider.component.html',
  styleUrls: ['./vertical-divider.component.scss'],
})
export class VerticalDividerComponent {
  @Input() vertical=false;
  @Input() height='';
}
